<template>
    <div>
        <v-select 
            :items="items"
            :return-object="isObjectValue"
            :value="defaultValue"
            label="Provinces"
            item-text="name"
            item-value="code"
            dense
            @change="changeValue"
        />
    </div>
</template>

<script>
import axios from 'axios'

export default {
    name: 'select-provinces',
    model: {
        prop: 'defaultValue',
        event: 'change'
    },
    props: {
        isObjectValue: {
            type: Boolean,
            default: false
        },
        defaultValue: {
            type: [Object, String]
        },
        filters: {
            type: Object
        },
        region: {
            type: String
        }
    },
    data() {
        return {
            items: []
        }
    },
    watch: {
        region:{
            handler(val) {
                console.log(val);
                if(!val) return
                this.loadRecords(`/address/region/${val}/provinces`)
            },
            immediate: true
        }
    },
    mounted() {
        if(!this.region) this.loadRecords()
    },
    methods: {
        loadRecords(path = '/address/provinces'){
            let self = this

            axios.get(path, {
                params: this.filters
            })
            .then(response => {
                let responseData = response.data

                if(!responseData.success) alert(responseData.message)

                self.items = responseData.data
            }).catch((error) => {
                alert(error.message)
            })
        },
        changeValue(value){
            this.$emit('change', value)
        }
    }
}
</script>